<script>
    import {fade} from 'svelte/transition';
    import {PASSWORD_TIP} from "../lib/constants.js";
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import user from "../stores/user";
    import Alert from "../stores/alerts";
    import {setFocusTo} from "../lib/lib";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import BirthdayControl from "../components/controls/BirthdayControl.svelte";
    import PhoneControl from "../components/controls/PhoneControl.svelte";
    import LastNameControl from "../components/controls/LastNameControl.svelte";
    import PasswordControl from "../components/controls/PasswordControl.svelte";

    export let forceSignup = false;

    let account = {
        id: 0,
        abbr: '',
        lastname: '',
        firstname: '',
        birthday: null,
        phone: '',
        email: '',
        password: '',
        allow_notifications: 1,
        country_id: '',
    }
    let countries = null;
    let confirmPassword = '';
    let completed = false;

    const initialize = () => {
        const onSuccess = result => {
            countries = result.countries;
        }

        const onFailure = err => {
        };

        R.handle(R.member.initialize, [], onSuccess, onFailure, LOADER.POPUP);
    }

    const submit = () => {
        const onSuccess = result => {
            completed = true;
            if ($app.debugNotifications) {
                Alert.alert("DEBUG!", `Member gets this link to his email:\n<a href="${result}" target="_blank">${result}</a>`);
            }
        }

        const onFailure = err => {
            if (err.code === 'same_object_identifier') {
                Alert.warning("Sign up", "There is already a member account with the email you provided.!", () => setFocusTo('signUpEmail'));
                return;
            }

            if (err.code === 'password_field_invalid') {
                Alert.warning("Sign up", PASSWORD_TIP, () => setFocusTo('password'));
                confirmPassword = '';
                return;
            }
        };


        if (account.password !== confirmPassword) {
            Alert.warning("Sign Up", "Your password confirmation is wrong!", () => {
                confirmPassword = null;
                setFocusTo('confirmPassword');
            });
            return;
        }

        let data = {
            action: 'signup',
            identifier: account.email,
            data: account,
        }

        R.handle(R.actionRequest.request, data, onSuccess, onFailure, LOADER.POPUP);
    }

    // DEBUG
    // account = {
    //     id: 0,
    //     abbr: 'Mr.',
    //     lastname: 'Nikoloudakis',
    //     firstname: 'Harrys',
    //     birthday: '1971-11-29',
    //     phone: '306932304558',
    //     email: 'harrys@source.gr',
    //     password: 'q44g972fpd',
    //     allow_notifications: 1,
    //     country_id: '85',
    // }
    // confirmPassword = 'q44g972fpd';

    if (!$user.token) {
        initialize();
    }
</script>

{#if countries}
    <div class="signup-overlay" transition:fade="{{ duration: 100 }}">
        <!--{#if !forceSignup}-->
        <!--    <div class="close-signup" on:click={ user.hideSignUp }>-->
        <!--        <AppIcon icon="x" size="24" strokeWidth="2"/>-->
        <!--    </div>-->
        <!--{/if}-->
        <div class="signup-content">
            <div class="content-left">
                {#if !forceSignup}
                    <button class="close-signup" on:click={ user.hideSignUp }>
                        <AppIcon icon="x" size="24" strokeWidth="2"/>
                    </button>
                {/if}

                <div class="form-logo mb-4">
                    <img src="/assets/images/logo-rect-green.png" alt="logo">
                </div>
                {#if !completed}
                    <h1 class="mb-3">Sign up</h1>
                    <form on:submit|preventDefault|stopPropagation="{ submit }">
                        <div class="form-group">
                            <label>Last name</label>
                            <LastNameControl bind:abbr="{ account.abbr }" bind:lastname="{ account.lastname }"
                                             required/>
                        </div>
                        <div class="form-group">
                            <label>First name</label>
                            <input type="text" class="form-control" bind:value="{ account.firstname }" required>
                        </div>
                        <div class="form-group">
                            <label>Phone</label>
                            <PhoneControl bind:value="{ account.phone }" required/>
                        </div>
                        <div class="form-group">
                            <label>Birthday</label>
                            <BirthdayControl bind:value="{ account.birthday }" required/>
                        </div>
                        <div class="form-group">
                            <label>Nationality</label>
                            <select class="form-select" bind:value="{ account.country_id }" required>
                                <option value="" disabled>select</option>
                                {#each countries as country}
                                    <option value="{ country.id }">{ country.name }</option>
                                {/each}
                            </select>
                        </div>
                        <hr>
                        <div class="form-group">
                            <label>Email</label>
                            <input type="email" class="form-control" id="signUpEmail" bind:value="{ account.email }"
                                   required>
                        </div>
                        <div class="form-group">
                            <label>Password</label>
                            <PasswordControl id="password" bind:value="{ account.password }"/>
                        </div>
                        <div class="form-group">
                            <label>Confirm password</label>
                            <PasswordControl id="confirmPassword" bind:value="{ confirmPassword }"/>
                        </div>
                        <hr>
                        <div class="form-check mb-2">
                            <input class="form-check-input" type="checkbox" value="" id="checkNotifications"
                                   checked="{ account.allow_notifications == 1 }"
                                   on:click={ () => account.allow_notifications = account.allow_notifications == 1 ? 0 : 1 }>
                            <label class="form-check-label" for="checkNotifications">
                                I wish to receive newsletters
                            </label>
                        </div>
                        <div class="form-check mb-3">
                            <input class="form-check-input" type="checkbox" value="" id="checkTerms" required>
                            <label class="form-check-label" for="checkTerms">
                                I have read and agree with the <a
                                    href="https://www.enormehotels.com/en/terms-conditions.php" target="_blank">Terms
                                and
                                conditions</a>
                            </label>
                        </div>
                        <div class="text-end">
                            <button class="btn btn-primary px-5">Submit</button>
                        </div>
                    </form>
                {:else}
                    <h1 class="mb-3">Congratulations!</h1>
                    <p>
                        Your registration is complete.
                    </p>
                    <p>
                        An email has been sent to you to confirm your registration and activate your account.
                    </p>
                {/if}
            </div>
            <div class="content-right">
                <svg viewBox="0 0 960 540" width="100%" height="100%" preserveAspectRatio="xMidYMax slice"
                     xmlns="http://www.w3.org/2000/svg" class="graphics circles">
                    <g fill="none" stroke="currentColor" stroke-width="100">
                        <circle r="234" cx="196" cy="23"></circle>
                        <circle r="234" cx="790" cy="491"></circle>
                    </g>
                </svg>
                <svg viewBox="0 0 220 192" width="220" height="192" fill="none" class="graphics dots">
                    <defs>
                        <pattern id="837c3e70-6c3a-44e6-8854-cc48c737b659" x="0" y="0" width="20" height="20"
                                 patternUnits="userSpaceOnUse">
                            <rect x="0" y="0" width="4" height="4" fill="currentColor"></rect>
                        </pattern>
                    </defs>
                    <rect width="220" height="192" fill="url(#837c3e70-6c3a-44e6-8854-cc48c737b659)"></rect>
                </svg>
                <div>
                    <div class="h1 line-height-1 mb-4">Welcome to<br>Enorme Hotels Loyalty Program</div>
                    <div>
                        Every stay brings you closer to unforgettable rewards! As a member, each time you check into any
                        of our exquisite hotels, you earn valuable points towards exciting perks, exclusive offers, and
                        luxurious experiences. Join today and elevate your travel journey with us!
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}
<style>
    .signup-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: var(--body-background);
        z-index: 9000;
    }

    .signup-content {
        display: flex;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 100%;
        height: 100vh;
        background: #fff;
        overflow: hidden;
    }

    .signup-content .content-left {
        position: relative;
        width: 400px;
        height: 100vh;
        padding: 2rem;
        overflow-y: auto;
    }

    .signup-content .content-left form {
        width: 100%;
    }

    .signup-content .content-right {
        position: relative;
        display: flex;
        align-items: center;
        width: calc(100% - 400px);
        /*color: #888;*/
        /*background: #232323;*/
        color: #807f7d;
        background: #000;
        padding: 5rem;
    }

    .signup-content .content-right .graphics {
        position: absolute;
        opacity: 0.1;
        color: #ccc;
    }

    .signup-content .content-right .circles {
        left: 0;
    }

    .signup-content .content-right .dots {
        top: -100px;
        right: -100px;
    }

    .signup-content .content-right .h1 {
        color: #D4B275;
    }

    .close-signup {
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 35px;
        padding: 10px;
        line-height: 1;
        border-radius: 50%;
        border: none;
        background: transparent;
        z-index: 9000;
    }

    .close-signup:hover {
        color: #000;
        background: #f5f5f5;
    }

    @media (max-width: 576px) {
        .signup-content .content-left {
            width: 100%;
        }
    }

    @media (max-width: 767px) {
        .signup-content .content-left {
            padding: 2rem;
        }

        .signup-content .content-right {
            display: none;
        }
    }

    @media (min-width: 768px) and (max-width: 991px) {
        .signup-content .content-left {
            padding: 2rem;
            width: 360px;
        }

        .signup-content .content-right {
            padding: 2rem;
            width: calc(100% - 360px);
        }
    }

    @media (min-width: 992px) and (max-width: 1199px) {

    }

    @media (min-width: 1200px) {
        .signup-content .content-left {
            width: 600px;
            padding-left: 8rem;
            padding-right: 5rem;
        }
    }

    /*@media (min-width: 728px) {*/
    /*    .close-signup {*/
    /*        color: #fff;*/
    /*    }*/
    /*}*/
</style>